import {AttachmentTO} from 'generated/JavaTO';
import _ from 'lodash';
import {SisName} from 'util/SisName';
import {Booking, Persurl} from 'generated/JavaTOmodifications'

export type CFValue = null | undefined | string | number

export interface CFMember extends Omit<AttachmentTO, 'data'> {
	data?: CFValue
}

export function isCFMember(d: CFMember | CFValue): d is CFMember {
	return _.isPlainObject(d) && _.has(d, 'dstField') && _.has(d, 'pos')
}

export interface CFSetOptions {
	pos?: number
	userInput?: boolean
}

export interface CFGetOptions {
	pos?: number
	forView?: boolean
}

export function isCFModel(m: { sisName: string }): m is Persurl | Booking {
	return m.sisName === SisName.Booking || m.sisName === SisName.Persurl
}

export type CFModel = { cf?: CFMember[], sisName?: SisName } & { [key in string]?: CFValue } & { [other in string]?: any }

export function isCFMemberNull(cfMember?: CFMember) {
	return !cfMember || !cfMember.data && cfMember.data !== 0 && !cfMember.lat && cfMember.lat !== 0 && !cfMember.lon && cfMember.lon !== 0 && !cfMember.lazy
}

export function isEqualCFValue(val1: CFValue | CFMember, val2: CFValue | CFMember): boolean {
	if (val1 === val2 || val1 == null && val2 == null) return true;
	if ((val1 as CFMember)?.lazy) val1 = _.omit(val1 as CFMember, 'data', 'preview', 'lazy')
	if ((val2 as CFMember)?.lazy) val2 = _.omit(val2 as CFMember, 'data', 'preview', 'lazy')
	return _.isEqual(val1, val2)
}
